import { ChangeEvent, ChangeEventHandler } from 'react';

import debounce from 'lodash.debounce';

import { addZeroBeforeDecimal } from 'helpers/utils';

interface Options {
  addLeadingZeroForDecimal?: boolean;
  negativeValueAllowed?: boolean;
  numberType?: 'decimal' | 'natural';
}

const handleChange = debounce(
  (
    event: ChangeEvent<HTMLInputElement>,
    options?: Options,
    callback?: ChangeEventHandler<HTMLInputElement>
  ) => {
    const addLeadingZeroForDecimal = options?.addLeadingZeroForDecimal;
    let value = event?.target?.value;
    value = addLeadingZeroForDecimal ? addZeroBeforeDecimal(value) : value;
    // eslint-disable-next-line no-param-reassign
    event.target.value = value;

    callback?.(event);
  },
  300
);

export { handleChange };
